


















































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import GroupListBase from "./GroupListBase";


	@Component
	export default class GroupList extends GroupListBase {

		showAllertToDeleteClick(itemsSelected: any) {
            //this.showAllertToDeleteClickBase(itemsSelected);
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            if (this.$store.state.askBeforeDelete) {              
               
                super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(), true);
            }
            else {
                this.itemsSelected = itemsSelected;
                this.callActionClick();
            }

		}

		selectRows(items: any) {
			super.selectRows(items);
		}

		created() {
			super.initializeRights('COR_Group_Create', 'COR_Group_Delete', 'COR_Group_Read', 'COR_Group_Update');
			super.created();
            super.setDetailName('GroupDetail');
            this.setDeleteMessage(this.$t('group.messageQuestionMain').toString(), this.$t('group.messageQuestionMain2').toString(), this.$t('group.messageQuestionMain3').toString());
			//this.useTable = store.state.groupListTableUse;
		};


		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }		
		deleteClick(elementId: any) { super.deleteClick(elementId); }

	}
